import { DocumentQuickPulse } from "./DocumentQuickPulse";

export interface EventDocumentQuickPulse extends DocumentQuickPulse {
    Name: string;
}
